import template from './compareTableColumn.html';

export default {
  template,
};
